import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiOrgs {
  static getOrgs(appId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/orgs`);
  }

  static getOrg(appId, orgId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/orgs/${orgId}`);
  }

  static createOrg(appId, modelOrg) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/orgs`, {
      method: "POST",
      body: { org: modelOrg },
    });
  }

  static updateOrg(appId, org) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/orgs/${org.id}`, {
      method: "PUT",
      body: { org },
    });
  }

  static deleteOrg(appId, orgId, newOrgId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/orgs/${orgId}?new_org_id=${newOrgId}`, {
      method: "DELETE",
    });
  }
}
